// extracted by mini-css-extract-plugin
module.exports = {"landingPage":"LandingPage_landingPage__1oDon","content":"LandingPage_content__18kaw","button":"LandingPage_button__1Cmc-"};